export class InstallLandingController {
    #env;
    #onChange;
    #view = "unsupported";
    #unsubscribers = [];
    #active = false;
    constructor(env, onChange) {
        this.#env = env;
        this.#onChange = onChange;
    }
    get view() {
        return this.#view;
    }
    start() {
        this.stop();
        this.#active = true;
        // Notify unconditionally, even when the seeded mode happens to equal the field's
        // pre-`start()` default ("unsupported") — `#setView`'s dedup guard is about real
        // transitions, and a fresh `start()` is always one, regardless of what it lands on.
        this.#view = this.#env.instructionMode();
        this.#onChange(this.#view);
        this.#unsubscribers.push(this.#env.onInstallAvailable(() => {
            if (this.#view === "ios" || this.#view === "safari-desktop" || this.#view === "unsupported") {
                this.#setView("installable");
            }
        }));
        this.#unsubscribers.push(this.#env.onAppInstalled(() => {
            this.#setView("success");
        }));
        this.#env
            .checkAlreadyInstalled()
            .then((installed) => {
            if (!this.#active || !installed || this.#view === "success")
                return;
            this.#setView("installed");
        })
            .catch(() => undefined);
    }
    stop() {
        this.#active = false;
        const unsubscribers = this.#unsubscribers;
        this.#unsubscribers = [];
        for (const unsubscribe of unsubscribers)
            unsubscribe();
    }
    async install() {
        const result = await this.#env.promptInstall();
        if (result === "accepted")
            this.#setView("success");
    }
    #setView(view) {
        if (this.#view === view)
            return;
        this.#view = view;
        this.#onChange(view);
    }
}
//# sourceMappingURL=install-landing-controller.js.map